import { getYouTubeThumbnail, isYouTubeUrl } from './youtubeUtils';

/** True if URL looks like a direct media file we can try as `<video src>`. */
export function looksLikeDirectVideoUrl(url: string): boolean {
  const u = url.trim().toLowerCase();
  if (!u.startsWith('http://') && !u.startsWith('https://')) return false;
  return /\.(mp4|webm|ogg|ogv|mov|m4v)(\?|$)/i.test(u) || u.includes('/video/');
}

/**
 * Static image URL for video thumb when not YouTube (exercise poster or empty).
 * For other URLs, returns null and caller may use `<video preload="metadata">`.
 */
export function getExerciseVideoThumbUrl(videoUrl: string | undefined, exerciseImage?: string | null): string | null {
  const v = videoUrl?.trim();
  if (!v) return null;
  if (isYouTubeUrl(v)) return getYouTubeThumbnail(v);
  const img = exerciseImage?.trim();
  return img || null;
}
